<template>
  <div v-if="!viewHistory">
    <div class="text-lg mb-4 text-left">รายการงบประมาณหน่วยงาน</div>
    <form @submit.prevent="onFilter" class="flex flex-row sm:mr-auto">
      <div class="sm:flex items-center sm:mr-4 mt-2">
        <!-- <label class="w-12 flex-none xl:w-auto xl:flex-initial mr-2">Field</label> -->
        <select
          v-model="filter.field"
          class="form-select w-full xxl:w-full mt-2 sm:mt-0 sm:w-auto"
        >
          <option
            v-for="opt in filterOption"
            :key="opt.value"
            :value="opt.value"
            >{{ opt.label }}</option
          >
        </select>
      </div>
      <div class="sm:flex items-center sm:mr-4 mt-2 xl:mt-0">
        <label class="w-12 flex-none xl:w-auto xl:flex-initial mr-2"
          >ค้นหา</label
        >
        <input
          v-model="filter.value"
          type="text"
          class="form-control sm:w-40 xxl:w-full mt-2 sm:mt-0"
          placeholder="Search..."
        />
      </div>
      <div class="mt-2 xl:mt-0">
        <button
          type="button"
          class="btn btn-primary w-full sm:w-16"
          @click="onFilter"
        >
          ค้นหา
        </button>
        <button
          type="button"
          class="btn btn-secondary w-full sm:w-16 mt-2 sm:mt-0 sm:ml-1"
          @click="onResetFilter"
        >
          ยกเลิก
        </button>
      </div>
    </form>
  </div>
  <div v-else class="flex justify-between">
    <div class="text-lg mb-4 text-left">
      <div>ประวัติการใช้งบประมาณหน่วยงาน</div>
      <div>
        {{ currentBudget.account_name }}<br />
        งบ: <b>{{ currentBudget.amount }}</b> | ใช้แล้ว:
        <b>{{ currentBudget.amountUse }}</b> | คงเหลือ:
        <b>{{ currentBudget.amountRemain }}</b>
      </div>
    </div>
    <div>
      <button class="btn" @click="toBudget" v-show="viewHistory">
        <ArrowLeftIcon class="w-4 h-4 mr-2 hidden md:block" />Back
      </button>
    </div>
  </div>
  <div
    id="tabulator"
    ref="tableRef"
    class="mt-5 table-report table-report--tabulator"
  ></div>
</template>

<script>
import Tabulator from 'tabulator-tables'
import { defineComponent, ref, onMounted, watch, reactive, computed } from 'vue'
import { myHeaders } from '../../utils/api'
import { useStore } from '@/store'
import feather from 'feather-icons'
import helpers from '@/helpers'
export default defineComponent({
  name: 'table-budget',
  props: {
    modelKey: {
      type: String
    },
    modelValue: {
      type: String,
      default() {
        return null
      }
    },
    company: {
      type: String,
      default() {
        return null
      }
    }
  },
  emits: ['setBudget', 'update:modelValue'],
  setup(props, context) {
    const store = useStore()
    const tableRef = ref()
    const tabulator = ref()
    const { numberFormat } = helpers
    store.dispatch('global/loadOptionBudget')

    const viewHistory = ref(false)

    const filter = reactive({
      field: 'bu_code',
      type: 'like',
      value: ''
    })
    const currentBudget = reactive({
      account_code: null,
      account_name: null,
      amount: null,
      amountRemain: null,
      amountUse: null,
      subledger: null
    })

    const columnsBudget = [
      {
        title: '',
        field: 'bu_code',
        formatter: cell => {
          const a = cash(`<div class="flex lg:justify-center items-center">
                        <a href="javascript:;" data-dismiss="modal" class="btn btn-sm btn-outline-warning ">
                         <i data-feather="check" class="w-4 h-4"></i>
                        </a>
                    </div>`)
          cash(a).on('click', () => {
            context.emit('update:modelValue', cell.getData().bu_code)
            context.emit('setBudget', cell.getData())
          })
          return a[0]
        }
      },
      {
        title: 'History',
        field: 'bu_code',
        formatter: cell => {
          const a = cash(`<div class="flex lg:justify-center items-center">
                        <a href="javascript:;" data-dismiss="modal" class="btn btn-sm btn-outline-info ">
                         <i data-feather="list" class="w-4 h-4"></i>
                        </a>
                    </div>`)
          cash(a).on('click', () => {
            loadHistory(cell.getData())
            viewHistory.value = true
            return false
          })
          return a[0]
        }
      },
      {
        title: 'Year',
        field: 'year'
      },
      {
        title: 'Budget No',
        field: 'bu_code'
      },
      {
        title: 'Budget Name',
        field: 'bu_name'
      },
      {
        title: 'Account No',
        field: 'account_code'
      },
      {
        title: 'Account Name',
        field: 'account_name'
      },
      {
        title: 'Subsidiary',
        field: 'subsidiary'
      },
      {
        title: 'Amount',
        field: 'amount',
        hozAlign: 'right',
        formatter: cell => {
          return numberFormat(cell.getData().amount)
        }
      },
      {
        title: 'Total used',
        field: 'total_used',
        hozAlign: 'right',
        formatter: cell => {
          return numberFormat(cell.getData().total_used)
        }
      }
    ]
    const columnsHistory = [
      {
        title: 'วันที่ทำรายการ',
        field: 'transaction_date',
        width: '8%',
        minWidth: 110
      },
      {
        title: 'การใช้งบประมาณ',
        field: 'status_doc_text',
        width: '8%',
        minWidth: 90
      },
      {
        title: 'รายละเอียด',
        field: 'detail',
        width: '23%',
        minWidth: 150
      },
      {
        title: 'ผู้เบิก',
        field: 'employee_name',
        width: '11%',
        minWidth: 150
      },
      {
        title: 'เลขที่เอกสาร',
        field: 'doc_no_full_req_withdraw',
        width: '8%',
        minWidth: 130
      },
      {
        title: 'จำนวนเงิน',
        field: 'amount',
        hozAlign: 'right',
        width: '8%',
        minWidth: 110,
        formatter: cell => {
          return numberFormat(cell.getData().amount)
        }
      },
      {
        title: 'หัก ณ ที่จ่าย',
        field: 'withholding_tax',
        hozAlign: 'right',
        width: '8%',
        minWidth: 80,
        formatter: cell => {
          return numberFormat(cell.getData().withholding_tax)
        }
      },
      {
        title: 'ภาษีมูลค่าเพิ่ม',
        field: 'vat',
        hozAlign: 'right',
        width: '8%',
        minWidth: 80,
        formatter: cell => {
          return numberFormat(cell.getData().vat)
        }
      },
      {
        title: 'รวมภาษี',
        field: 'amount_vat',
        hozAlign: 'right',
        width: '8%',
        minWidth: 100,
        formatter: cell => {
          return numberFormat(cell.getData().amount_vat)
        }
      },
      {
        title: 'ค่าใช้จ่ายทางบัญชี',
        field: 'amount_account',
        hozAlign: 'right',
        cssClass: 'font-bold',
        width: '8%',
        minWidth: 110,
        formatter: cell => {
          return numberFormat(cell.getData().amount_account)
        }
      }
    ]

    const initTabulator = async company => {
      const url = company
        ? process.env.VUE_APP_API_URL +
          '/admin/budget/getBudgetBu?company=' +
          company
        : process.env.VUE_APP_API_URL + '/admin/budget/getBudgetBu'

      tabulator.value = new Tabulator(tableRef.value, {
        layout: 'fitDataStretch',
        ajaxURL: url,
        ajaxLoader: true,
        ajaxFiltering: true,
        ajaxSorting: true,
        pagination: 'remote',
        placeholder: 'ไม่พบข้อมูลที่ต้องการ',
        paginationSize: 10,
        paginationSizeSelector: [10, 20, 30, 40],
        ajaxConfig: {
          method: 'GET',
          headers: await myHeaders()
        },
        ajaxResponse: async (url, params, response) => {
          if (response.code == 200) {
            return response.data
          } else {
            await store.commit('notification/toast', {
              type: 'danger',
              message: 'message',
              description: 'desc'
            })
            await store.commit('notification/toastShow', {})
            return false
          }
        },

        ajaxURLGenerator: (url, headers, params) => {
          if (params) {
            const urlNew = []
            if (params.sorters.length > 0) {
              urlNew.push(`sortBy=${params.sorters[0].field}`)
              urlNew.push(`sortDesc=${params.sorters[0].dir == 'desc'}`)
            }
            if (params.page) {
              urlNew.push(`current_page=${params.page}`)
            }
            if (params.size > 0) {
              urlNew.push(`per_page=${params.size}`)
            }
            if (params.filters.length > 0) {
              urlNew.push(`filterBy=${params.filters[0].field}`)
              urlNew.push(`filter=${params.filters[0].value}`)
            }
            const q = url.indexOf('?') == -1 ? '?' : '&'
            return urlNew.length ? `${url}${q}${urlNew.join('&')}` : url
          } else {
            return url
          }
        },
        columns: [],
        renderComplete() {
          // console.log('render budget')
          feather.replace({
            'stroke-width': 1.5
          })
        }
      })
    }

    const onFilter = () => {
      tabulator.value.setFilter(filter.field, filter.type, filter.value)
    }

    // On reset filter
    const onResetFilter = () => {
      filter.field = 'bu_code'
      filter.type = 'like'
      filter.value = ''
      if (props.company) {
        tabulator.value.setData(
          process.env.VUE_APP_API_URL +
            '/admin/budget/getBudgetBu?company=' +
            props.company
        )
      } else {
        tabulator.value.setData(
          process.env.VUE_APP_API_URL + '/admin/budget/getBudgetBu'
        )
      }
      // onFilter()
    }

    watch(
      () => props.company,
      newVal => {
        tabulator.value.setData(
          process.env.VUE_APP_API_URL +
            '/admin/budget/getBudgetBu?&company=' +
            newVal
        )
      }
    )

    const filterOption = computed(() => store.state.global.optionBudget)

    const loadHistory = budget => {
      currentBudget.account_code = budget.account_code
      currentBudget.account_name = budget.account_name
      currentBudget.subledger = budget.subledger
      currentBudget.amount = numberFormat(budget.amount)
      currentBudget.amountRemain = numberFormat(budget.amountRemain)
      currentBudget.amountUse = numberFormat(budget.amountUse)

      tabulator.value.setData(
        `${
          process.env.VUE_APP_API_URL
        }/admin/budgetTransaction/getHistoryReserve?comp_no=${
          budget.comp_no
        }&year=${budget.year}&bu_code=${budget.bu_code}&account_code=${
          budget.account_code
        }&subsidiary=${budget.subsidiary}${
          currentBudget.subledger ? '&subledger=' + currentBudget.subledger : ''
        }`
      )
      tabulator.value.setColumns(columnsHistory)
    }

    const toBudget = async () => {
      viewHistory.value = false
      const url = props.company
        ? process.env.VUE_APP_API_URL +
          '/admin/budget/getBudgetBu?company=' +
          props.company
        : process.env.VUE_APP_API_URL + '/admin/budget/getBudgetBu'
      tabulator.value.setData(url)
      tabulator.value.setColumns(columnsBudget)
    }

    onMounted(async () => {
      // console.log('mounted budget')
      await initTabulator(props.company)
      tabulator.value.setColumns(columnsBudget)
    })
    return {
      onResetFilter,
      filterOption,
      tableRef,
      filter,
      onFilter,
      viewHistory,
      toBudget,
      currentBudget
    }
  }
})
</script>
